<div class="select-container" [class.readonly]="readonly">
  <div class="header">
    <div class="label">{{ entityLabel }}</div>

    <app-form-switch-button
      [text]="switchBtnText"
      (switchForm)="onClickSwitchBtn()"
    />
  </div>

  <div
    #integrationsEntitySearchDropdown="ngbDropdown"
    ngbDropdown
    class="dropdown d-flex gap-2"
  >
    <div class="control" [class]="{ disabled: searchControl.disabled }">
      <input
        ngbDropdownToggle
        type="text"
        class="autocomplete-input"
        [formControl]="searchControl"
        [placeholder]="placeholder"
        [class.no-source]="!sources.length"
        (input)="integrationsEntitySearchDropdown.open()"
      >

      <div
        class="source-dropdown-wrapper"
        ngbDropdown
        [hidden]="!sources.length"
      >
        <button
          ngbDropdownToggle
          type="button"
          class="source-dropdown-trigger"
          [disabled]="searchControl.disabled || readonly"
          [class]="{'opened': dropdownOpen}"
        >
          <div class="source-logo-wrapper">
            <img
              [src]="externalSourceIconsPathRecord[selectedSource]"
              [alt]="selectedSourceLabel + ' logo'"
            >
          </div>

          <div class="text" [title]="selectedSourceLabel">{{ selectedSourceLabel }}</div>
          <span class="icon ic-select-20"></span>
        </button>

        <div class="dropdown-menu sources-dropdown" ngbDropdownMenu>
          <ul class="sources list-unstyled mb-0">
            @for (sourceOption of sources; track sourceOption) {
              <li class="source-item">
                <button
                  ngbDropdownItem
                  type="button"
                  class="d-flex gap-8 align-items-center"
                  (click)="selectSource(sourceOption.value)"
                >
                  <div class="source-logo-wrapper">
                    <img
                      [src]="externalSourceIconsPathRecord[sourceOption.value.toString()!]"
                      [alt]="sourceOption.label + ' logo'"
                    >
                  </div>

                  <div>{{ sourceOption.label }}</div>
                </button>
              </li>
            }
          </ul>
        </div>
      </div>
    </div>

    <div class="extra-control hide-empty"><ng-content/></div> <!-- DO NOT LET IT BE UNWRAPPED-->

    <div
      ngbDropdownMenu
      class="dropdown-menu entities-dropdown"
      [hidden]="!sources.length"
    >
      @switch (entityType) {
        @case (EntityType.Individual) {
          @for (individualOption of individuals; track individualOption) {
            <button
              ngbDropdownItem
              type="button"
              (click)="selectIndividual(individualOption)"
            >
              <ng-container
                [ngTemplateOutlet]="individualOptionLabel"
                [ngTemplateOutletContext]="{ individual: individualOption }"
              />
            </button>
          } @empty {
            <div class="no-options bg-transparent px-3 py-1">{{ noOptionsText }}</div>
          }
        }
        @case (EntityType.Company) {
          @for (companyOption of companies; track companyOption) {
            <button
              ngbDropdownItem
              type="button"
              (click)="selectCompany(companyOption)"
            >
              <ng-container
                [ngTemplateOutlet]="companyOptionLabel"
                [ngTemplateOutletContext]="{ company: companyOption }"
              />
            </button>
          } @empty {
            <div class="no-options bg-transparent px-3 py-1">{{ noOptionsText }}</div>
          }
        }
        @case (EntityType.Trust) {
          @for (trustOption of trusts; track trustOption) {
            <button
              ngbDropdownItem
              type="button"
              (click)="selectTrust(trustOption)"
            >
              <ng-container
                [ngTemplateOutlet]="trustOptionLabel"
                [ngTemplateOutletContext]="{ trust: trustOption }"
              />
            </button>
          } @empty {
            <div class="no-options bg-transparent px-3 py-1">{{ noOptionsText }}</div>
          }
        }
      }
    </div>
  </div>

  @if (displayValidationError) {
    <app-validation-error [customErrors]="customErrors"></app-validation-error>
  }
</div>


<ng-template #individualOptionLabel let-individual="individual">
  <div class="individual-data option-label">
    <div>
      <i class="icon ic-my-account-20"></i>
    </div>

    <div class="flex-grow-1">
      <div class="d-flex align-items-center justify-content-between">
        <div class="title">{{ individual?.fullNameWithMiddle | defaultValue }}</div>

        @if (individual.individualId && [individual.individualId] && individual.isVerified) {
          <i class="icon ic-verification-inverted-20 bg-green"></i>
        }
      </div>

      <div class="details">
        <div class="details-item">
          <div class="prop">DoB</div>
          <div class="prop-value">{{ individual?.dob | dateFormat | defaultValue }}</div>
        </div>

        <div class="details-item">
          <div class="prop">Address</div>
          <div
            class="prop-value">{{ individual?.address?.normalizedFullAddress | defaultValue }}
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #companyOptionLabel let-company="company">
  <div class="company-data option-label align-items-center">
    <div>
      <i class="icon ic-companies-20"></i>
    </div>

    <div>
      <div class="title mb-2">{{ company.name }}</div>
      <div class="prop-value">
        <span>ACN: </span>
        <span>{{ company.acn | acn }}</span>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #trustOptionLabel let-trust="trust">
  <div class="company-data option-label align-items-center">
    <div>
      <i class="icon ic-trusts-20"></i>
    </div>

    <div>
      <div class="title mb-2">{{ trust.name }}</div>
      <div class="prop-value">
        <span>ABN: </span>
        <span>{{ trust.abn | abn }}</span>
      </div>
    </div>
  </div>
</ng-template>
